module.exports = __webpack_public_path__ + "static/img/banner13.09e66337.png";